import { render, staticRenderFns } from "./pondAlertsTab.vue?vue&type=template&id=09d96c1b&"
import script from "./pondAlertsTab.vue?vue&type=script&lang=js&"
export * from "./pondAlertsTab.vue?vue&type=script&lang=js&"
import style0 from "./pondAlertsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports